import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
//import * as Chart from "chart.js";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { url } from "inspector";

import { DataStream } from "src/app/shared/models/kpi.model";

@Component({
  selector: "gen-kpi-doughnut",
  templateUrl: "./gen-kpi-doughnut.component.html",
  styleUrls: ["./gen-kpi-doughnut.component.scss"],
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenKpiDoughnutComponent implements OnInit, OnDestroy {
  @Input() size: string;
  @Input() id: string = "";
  @Input() cutout: string;
  @Input() centerContent: TemplateRef<any>;
  @Input() data: DataStream;
  @Input() dataLabels: boolean = false;
  @Input() customLegend: boolean = false;

  canvas: any;
  ctx: any;
  myChart: any;
  chartId: string;

  constructor() { }

  ngOnInit() {
    this.chartId = "chart_" + this.id;
  }

  ngOnDestroy() {
    if (this.myChart) this.myChart.destroy();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.drawChart();
  }

  ngAfterViewInit() {
    this.drawChart();
  }

  getDataSets(): Array<any> {
    let dataset = {
      label: this.data.descr,
      data: this.data.values,
      txtValues: this.data.txtValues,
      backgroundColor: this.data.bgColors,
      hoverBackgroundColor: this.data.bgColors,
      code: this.data.streamCode,
      cutout: this.cutout,
      datalabels: this.dataLabels
        ? {
          labels: {
            value: {
              align: "top",
              font: { size: 14, weight: "bold" },
              color: "white",
              formatter: (value, ctx) => {
                if (value < 10) return "";
                else return value + "%";
              },
            },
            metadata: {
              align: "center",
              color: "white",
              font: { size: 12, weight: 400 },
              formatter: function (value, ctx) {
                if (value < 20) return "";
                return ctx.dataset.txtValues[ctx.dataIndex];
              },
            },
          },
        }
        : null,
    };
    return [dataset];
  }

  drawChart() {
    if (this.myChart) this.myChart.destroy();

    this.canvas = document.getElementById(this.chartId);
    if (!this.canvas) return;

    this.ctx = this.canvas.getContext("2d");
    Chart.defaults.font = {
      family: "Rubik",
      size: 14,
    };

    let plugins = [];
    if (this.dataLabels) {
      plugins.push(ChartDataLabels);
    }

    this.myChart = new Chart(this.ctx, {
      type: "doughnut",
      data: {
        datasets: this.getDataSets(),
        labels: this.data.labels,
      },
      plugins: plugins,
      options: {
        maintainAspectRatio: false,
        animation: {
          duration: 0,
        },
        plugins: {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          // htmlLegend: {
          //   containerID: "legend-container_" + this.id,
          // },
          legend: {
            display: true,
            position: "top",
            align: "center",
            rtl: true,
            onClick: null,
            labels: {
              usePointStyle: true,
              boxWidth: 10,
              boxHeight: 10,
              font: {
                size: 12,
              },
              padding: 10,
            },
          },
          tooltip: {
            yAlign: 'top',
            displayColors: false,
            rtl: true,
            padding: 6,
            enabled: true,
            backgroundColor: "rgb(235, 238, 242)",
            bodyColor: "rgb(0, 148, 221)",
            titleColor: "rgb(0, 148, 221)",

            callbacks: {
              title: (context) => {
                if (this.id.startsWith("today_orders")) return "";
                return context[0].label;
              },
              label: (context) => {
                return context.dataset["txtValues"][context.dataIndex];
              },
            },
          },
        },
      },
    });
  }
}
